import React from "react";
import VulnerabilitiesDetailsComponent from "./VulnerabilitiesDetailsComponent";

const DetailsContainer = () => {
  return <VulnerabilitiesDetailsComponent />;
};

export default DetailsContainer;
